export default __webpack_public_path__ + "static/media/IC00008-live_mentoring_card.9b66239b.svg";